import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.UsersPage.SetDelegatePopupContent', {
    title: 'Substitute approvals',
    selectDelegateText: 'Substitute',
    selectDelegatePlaceholderText: 'Choose a person',
    contentDescriptionText: `
        Selected Substitute will be approving requests on behalf of {name} unless removed. {name} will not see any approval requests while Substitute for them is enabled.{br}
        Only users who have not substituted their role can be set as Substitutes.`,
    pleaseNoteText: 'Important:',
    timezoneHintText: `
        {pleaseNote} The dates you set are tied to the user profile's time zone. This means that the time zone you choose only affects how the saved dates are displayed. For example, if you delegate your authority to a colleague in a different time zone, you can select their time zone to ensure the dates are displayed correctly for them.`,
    delegateColumnTitle: 'Substitute',
    startDateColumnTitle: 'Start date',
    endDateColumnTitle: 'End date',
    timeZoneTitle: 'Time zone',
    timeZonePlaceholder: 'Choose a time zone',
    buttonRemove: 'Remove',
    buttonDone: 'Done',
    buttonDoneTitle: 'Apply changes and close the popup',
    delegateSetNotificationMessage: 'Substitute set up',
    delegateClearNotificationMessage: 'Substitute removed',
    required: 'Field is required',
    dateFromCantBeAfterDateTo: 'The start date must be earlier than the end date',
});
